// Faixa "Aceitamos:" exibindo as bandeiras de cartão aceitas pelo Asaas.
// Todos os ícones são SVG inline (zero requisições HTTP).
import * as React from 'react';
import { ACCEPTED_BRANDS } from './brands';

interface AcceptedCardBrandsProps {
  className?: string;
}

export function AcceptedCardBrands({ className }: AcceptedCardBrandsProps) {
  return (
    <div
      className={
        'flex flex-wrap items-center gap-x-3 gap-y-2 pt-4 border-t border-slate-100 ' +
        (className ?? '')
      }
    >
      <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
        Aceitamos:
      </span>
      <ul
        aria-label="Bandeiras de cartão aceitas"
        className="flex flex-wrap items-center gap-1.5"
      >
        {ACCEPTED_BRANDS.map(({ id, label, Icon }) => (
          <li key={id} title={label} aria-label={label} className="leading-none">
            <Icon className="h-6 w-auto" />
          </li>
        ))}
      </ul>
    </div>
  );
}
